import AutoLogin from "./AutoLogin";
import LoginId from "./LoginId";
import LoginPassword from "./LoginPassword";

export default class Authentication {
  public static of(loginId: LoginId, loginPassword: LoginPassword, autoLogin: AutoLogin): Authentication {
    return new Authentication(loginId, loginPassword, autoLogin);
  }
  public static empty(): Authentication {
    return Authentication.of(LoginId.empty(), LoginPassword.empty(), AutoLogin.empty());
  }

  private readonly _loginId: LoginId = LoginId.empty();
  private readonly _loginPassword: LoginPassword = LoginPassword.empty();
  private readonly _autoLogin: AutoLogin = AutoLogin.empty();

  constructor(loginId: LoginId, loginPassword: LoginPassword, autoLogin: AutoLogin) {
    this._loginId = loginId;
    this._loginPassword = loginPassword;
    this._autoLogin = autoLogin;
  }

  get loginId() {
    return this._loginId;
  }

  get loginPassword() {
    return this._loginPassword;
  }

  get autoLogin() {
    return this._autoLogin;
  }
}